import { isFilePreviewable, isImage } from "@sp-crm/core";
import { GetFileQuery } from "generated/graphql";
import React from "react";
import { DocumentRender } from "./pdf/document-render";

interface FilePreviewProps {
    file: GetFileQuery["getFile"];
}

export const FilePreview: React.FC<FilePreviewProps> = props => {
    const { file } = props;

    const [pageNumber, setPageNumber] = React.useState(1);

    if (!isFilePreviewable(file)) {
        return null;
    }

    if (isImage(file.mimeType)) {
        return (
            <div>
                <p>File preview</p>
                <div className="rounded shadow-sm md:shadow-lg border border-gray-50">
                    <img
                        src={`/api/files/download/${file.id}`}
                        alt={file.originalFilename ?? "Image preview"}
                        className="w-full h-auto"
                    />
                </div>
            </div>
        );
    }

    return (
        <div>
            <p>File preview</p>
            <DocumentRender
                documentUrl={`/api/files/download/${file.id}`}
                pageNumber={pageNumber}
                setPageNumber={setPageNumber}
            />
        </div>
    );
};
